import React from "react";
import ReactDOM from "react-dom";
// import './assets/scss/style.scss';
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import rootReducer from "./redux/reducer";
import packageJson from "../package.json";
export const store = createStore(rootReducer, applyMiddleware(thunk));
// Function to dynamically add script tag with version from package.json
const addVersionedScript = () => {
  const script = document.createElement("script");
  script.src = `/static/js/main.js?v=${packageJson.version}`;
  script.async = true;
  document.body.appendChild(script);
};

// Ensure script is added after React app is rendered
addVersionedScript();
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
